import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import config from '../../../config';
import {Term} from "../../../classes/term";

@Injectable()
export class kanTermsService {
    constructor(private http: HttpClient) {
    }

    public getTerms(): Promise<Term[]> {
        return new Promise((resolve, reject) => {

            this.http.get(`${config.apiRootUrl}/api/terms`)
                .toPromise()
                .then((response: any) => {

                    resolve(response as Term[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public addTerm(term: Term): Promise<Term> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/terms`, term)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Term);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public updateTerm(term: Term): Promise<Term> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/terms/${term.id}`, term)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Term);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public removeTerm(term: Term): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/terms/${term.id}`, {})
                .toPromise()
                .then((response: any) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/terms.ts